import { forwardRef, Ref } from 'react';
import { ViewType } from '@/screens/profile/profile-screen.types.ts';

export const ViewButton = forwardRef(
	(
		{
			view,
			activeView,
			onClick,
			label
		}: {
			view: ViewType;
			activeView: ViewType;
			onClick: (view: ViewType) => void;
			label: string;
		},
		ref: Ref<HTMLButtonElement>
	) => (
		<button
			ref={ref}
			className={`view-button ${activeView === view ? 'active' : ''}`}
			onClick={() => onClick(view)}>
			{label}
		</button>
	)
);
